import styled from "styled-components";

const StyledContent = styled.div`
  padding: 3rem;
`;

export default StyledContent;
